<template>
    <span :class="['rtb-status-badge', `rtb-status-badge--${tone}`]" :title="withHint ? hint : undefined">
        <span class="rtb-status-badge__dot" aria-hidden="true"></span>
        {{ label }}
    </span>
</template>

<script setup>
import { computed } from 'vue';
import { RTB_STATUS_HINT, RTB_STATUS_TONE } from '../../../../constants/rtbCampaigns';

const props = defineProps({
    status: { type: String, required: true },
    label: { type: String, required: true },
    withHint: { type: Boolean, default: true },
});

const tone = computed(() => RTB_STATUS_TONE[props.status] || 'neutral');
const hint = computed(() => RTB_STATUS_HINT[props.status] || '');
</script>

<style scoped lang="scss">
@use '../../../../../scss/pages/admin/admin-tokens' as *;

.rtb-status-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 10px;
    border-radius: 999px;
    font-size: $font-size-sm;
    font-weight: 600;
    line-height: 1.4;
    white-space: nowrap;
    cursor: default;

    &--success { background: $admin-success-bg; color: $admin-success-color; }
    &--warning { background: $admin-warning-bg; color: $admin-warning-color; }
    &--danger { background: $admin-danger-bg; color: $admin-danger-color; }
    &--neutral { background: #eef2ff; color: #4338ca; }
    &--muted { background: $admin-bg-hover; color: $admin-text-muted; }
}

.rtb-status-badge__dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
}
</style>
